import apiClient from '@uniqcamp/shared/services/api.service';

const urlBase64ToUint8Array = (base64String: string): Uint8Array => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const arrayBufferToBase64 = (buffer: ArrayBuffer | null): string => {
  const bytes = new Uint8Array(buffer || new ArrayBuffer(0));
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const subscribeUserToPush = async (): Promise<{ success: boolean; message?: string }> => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { success: false, message: 'Push not supported' };
  }

  try {
    const reg = await navigator.serviceWorker.ready;
    const res = await apiClient.get('/push/vapid-public-key');
    const data = res.data as { success?: boolean; publicKey?: string };
    if (!data?.success || !data.publicKey) {
      return { success: false, message: 'Push not configured on server' };
    }

    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey).buffer as ArrayBuffer,
    });

    await apiClient.post('/push/subscribe', {
      endpoint: subscription.endpoint,
      keys: {
        p256dh: arrayBufferToBase64(subscription.getKey('p256dh')),
        auth: arrayBufferToBase64(subscription.getKey('auth')),
      },
    });

    return { success: true };
  } catch (err: unknown) {
    const e = err as { response?: { data?: { message?: string } }; message?: string };
    const msg = e.response?.data?.message || e.message || 'Subscribe failed';
    return { success: false, message: msg };
  }
};

export const requestNotificationPermission = (): Promise<string> => {
  if (!('Notification' in window)) return Promise.resolve('unsupported');
  if (Notification.permission === 'granted') return Promise.resolve('granted');
  if (Notification.permission === 'denied') return Promise.resolve('denied');
  return Notification.requestPermission();
};
